export default "__VITE_ASSET__tq4KONTA__"